import { ErrorScreen } from '@components/error-screen';
import { useScopedTranslate } from '@locale/translate';

export const PageNotFound = ({ message }: { message: string }) => {
  const { t } = useScopedTranslate(locale);
  return <ErrorScreen code={404} heading={t('notFound')} message={message} />;
};

const locale = {
  en: {
    notFound: 'Not found',
  },
};
